
import './marketerForm.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import zone from '../../service/zone';
import user from '../../service/user';
import menuLayout from '../../directive/menu-layout';
import marketer from '../../service/marketer';

import routing from './marketerForm.routes';
import MarketerFormController from './marketerForm.controller';

export default angular.module('page.marketerForm', [
		uirouter,
		menuLayout,
		'uiSwitch',

		marketer,
		user,
		zone
	])
	.config(routing)
	.controller('MarketerFormController', MarketerFormController)
	.name;



// WEBPACK FOOTER //
// ./src/page/marketerForm/index.js